import React from "react";
import Sidemenu from "../SidemenuComponent/Sidemenu";
import Topbar from "../TopbarComponent/Topbar";

import "./layout.css";
import { Outlet } from "react-router-dom";

const Layout = ({ children }) => {
  return (
    <div class="layout-page wrapper">
      <Topbar />
      <Sidemenu />
      <div id="content">
        <Outlet/>
      </div>
    </div>
  );
};

export default Layout;
